
import { defineComponent, onMounted } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
    name: 'Overview',
    setup() {
        const router = useRouter();

        onMounted(() => {
            router.push({ name: 'maps' });
        });

        return {};
    },
});
